import { render, staticRenderFns } from "./BankCCWarningPopup.vue?vue&type=template&id=2a04537a"
import script from "./BankCCWarningPopup.vue?vue&type=script&lang=js"
export * from "./BankCCWarningPopup.vue?vue&type=script&lang=js"
import style0 from "./BankCCWarningPopup.vue?vue&type=style&index=0&id=2a04537a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports